import styled from 'styled-components';
import colors from 'styles/colors';

export const Container = styled.div<{ open: boolean }>`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: ${(props) => (props.open ? '0' : 'auto')};
  z-index: 5;
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: ${(props) => (props.open ? colors.$white : 'transparent')};

  .ask-edital-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    flex-shrink: 0;
    padding: 12px 16px;
    border: none;
    background: #4b5058;
    color: ${colors.$white};
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;

    .material-icons {
      font-size: 20px;
    }
  }

  .ask-edital-panel {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    background: ${colors.$white};
  }

  .ask-edital-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-shrink: 0;
    padding: 12px 16px;
    border-bottom: 1px solid ${colors.$gray300};

    h5 {
      margin: 0;
      color: ${colors.$dark};
      font-size: 20px;
      font-weight: 600;
    }
  }

  .ask-edital-saved-toggle {
    border: 1px solid ${colors.$gray400};
    border-radius: 6px;
    background: ${colors.$white};
    color: ${colors.$gray700};
    font-size: 14px;
    padding: 6px 16px;
    white-space: nowrap;

    &.is-active {
      border-color: ${colors.$primary};
      color: ${colors.$primary};
    }
  }

  .ask-edital-body {
    flex: 1;
    min-height: 0;
    display: flex;
    min-width: 0;
  }

  .ask-edital-chat {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  .ask-edital-saved {
    width: 30%;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    min-height: 0;
    border-left: 1px solid ${colors.$gray300};
  }

  .ask-edital-saved-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid ${colors.$gray300};

    h6 {
      margin: 0;
      font-size: 15px;
      font-weight: 600;
      color: ${colors.$dark};
    }
  }

  .ask-edital-saved-close {
    padding: 0;
    border: none;
    background: none;
    color: ${colors.$gray600};
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
  }
`;
